import React from "react";

const HoPolygonInvisible = ({ size = 24, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="12,3 20,9 17,21 7,21 4,9" />

    <line x1="2" y1="2" x2="22" y2="22" />
  </svg>
);

export default HoPolygonInvisible;
